import React from 'react';
import shortid from 'shortid';
import PropTypes, { shape } from 'prop-types';
import ItemList from './ItemList';
import { ReactComponent as LogoWomIcon } from '../../../images/logowom.svg';
import {
  FacebookIcon,
  TwitterIcon,
  InstagramIcon,
  YoutubeIcon,
} from '../../../images/footer';
import {
  ContainerStyled,
  SocialNetworks,
  SocialIcons,
  InnerContentStyled,
} from './styles/FooterContentStyled';

const FooterContent = ({ gradient, links }) => {
  const socialIcons = {
    facebook: <FacebookIcon />,
    twitter: <TwitterIcon />,
    instagram: <InstagramIcon />,
    youtube: <YoutubeIcon />,
  };

  return (
    <ContainerStyled gradient={gradient}>
      <InnerContentStyled>
        <LogoWomIcon />

        <SocialNetworks>
          <p>Síguenos en:</p>
          <SocialIcons>
            {links.socialNetworks.map(item => (
              <a
                key={shortid.generate()}
                href={item.url}
                rel="noopener noreferrer"
                target="_blank"
              >
                {socialIcons[item.label.toLowerCase()]}
              </a>
            ))}
          </SocialIcons>
        </SocialNetworks>

        <ItemList tag="mi-wom" title="Sobre WOM" data={links.miWom} />
        <ItemList tag="contact" title="Contacto" />
        <ItemList
          tag="help-center"
          title="Te ayudamos"
          data={links.helpCenter}
        />
        <ItemList
          tag="legal-terms"
          title="Términos legales"
          data={links.legalTerms}
        />
      </InnerContentStyled>
    </ContainerStyled>
  );
};

FooterContent.propTypes = {
  links: PropTypes.shape({
    miWom: PropTypes.arrayOf(
      shape({
        label: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })
    ),
    helpCenter: PropTypes.arrayOf(
      shape({
        label: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })
    ),
    legalTerms: PropTypes.arrayOf(
      shape({
        label: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })
    ),
    socialNetworks: PropTypes.arrayOf(
      shape({
        label: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  gradient: PropTypes.bool,
};

FooterContent.defaultProps = {
  gradient: false,
};

export default FooterContent;
